module.exports = __webpack_public_path__ + "static/media/Levin_Range_Seat_2.483ce946.jpg";